namespace Areas.Budget.BudgetEntry {
    "use strict";




}